import React, { useRef } from 'react';

import cs from 'classnames';
import moment from 'moment-timezone';

import Button from 'components/shared/Buttons/Button/Button';
import Popover from 'components/shared/Popovers/Popover/Popover';

const Years = ({ currentMonth, changeMonthHandle }) => {
  const dateFormat = 'YYYY';
  const formattedYear = moment(currentMonth).format(dateFormat);
  const currentYear = moment().year();
  const currentYearRef = useRef(null);

  const handleYearSelect = (selectedYear) => {
    const newDate = moment(currentMonth).year(selectedYear);
    changeMonthHandle(newDate);
  };

  // list of 10 years ago and 10 years before
  const yearList = Array.from({ length: 21 }, (_, index) => currentYear - 10 + index)
    .toString()
    .split(',');

  return (
    <Popover
      isFixed
      customButtonTrigger={
        <Button
          text={formattedYear}
          variant="tertiary"
          size="xs"
          iconRight="chevron-down-linear"
          iconColor="neutral"
          onClick={() =>
            currentYearRef?.current?.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }
        />
      }>
      <div className="mr-[6px] max-h-[420px] overflow-auto">
        {yearList.map((option, index) => (
          <div
            key={index}
            ref={formattedYear === option ? currentYearRef : null}
            className={cs(
              'flex gap-x-2 py-[5px] !pl-4 pr-[14px] transition-all hover:bg-primary-50',
              formattedYear === option && 'bg-primary-50'
            )}
            onClick={() => {
              handleYearSelect(option);
              close();
            }}>
            <span className="text-sm font-400 text-primary-900">{option}</span>
          </div>
        ))}
      </div>
    </Popover>
  );
};

export default Years;
